module.exports = __webpack_public_path__ + "static/easyeducation-hero-min-0f8b0b0da546f76866a31dbc6cbf7d20.jpg";